import { useEffect } from 'react';

import { isBreakpoint } from 'helpers';
import { useSafeState } from 'hooks';

export const useScreenResize = () => {
  const [showElement, setShowElement] = useSafeState({ mobile: false, desktop: false });

  useEffect(() => {
    const setScreenSize = () => setShowElement({ mobile: false, desktop: isBreakpoint(1024) });

    // For initial load of the page
    setScreenSize();

    // Set element visibility on mobile or desktop
    window.addEventListener('resize', setScreenSize);
    return () => window.removeEventListener('resize', setScreenSize);
  }, []);

  return { showElement, setShowElement };
};
